module.exports = "/static/assets/22fbd0a5bc8f309a13c68f5dd7bb63f0.png";